import axios from 'axios';
import {
  MDBBadge,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardFooter,
  MDBCardHeader,
  MDBCardImage,
  MDBCardTitle,
  MDBChip,
  MDBCol,
  MDBContainer,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
  MDBSpinner,
  MDBTable,
  MDBTableBody
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CategoryContext } from '../context/CategoryContext';
import { DomainContext } from '../context/DomainProvider';
import Inventory from '../inventory/Inventory';
const Requests = () => {

  const [requests, setRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const {domainImages} = useContext(DomainContext);
  const {categoryImages} = useContext(CategoryContext);
  const baseUrl= process.env.REACT_APP_INVENTORY_URL;
  const [refetchTrigger, setRefetchTrigger] = useState(false);


  const fetchItems = useCallback(async () => {
    
    try {
      const response = await axios.get(`${baseUrl}/requests`);
     
      if (response.data.length > 0) {
        setRequests(response.data); // Set the first object of the array to the data state
      } else {
        navigate('/no-requests'); // No data received, navigate to '/no-requests'
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  },[baseUrl,navigate]);

  

  useEffect(() => {
    fetchItems()
  }, [fetchItems]);

  useEffect(() => {
    if (refetchTrigger) {
      fetchItems();
      setRefetchTrigger(false); // Reset the trigger after fetching
    }
  }, [refetchTrigger]);
  
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };


  const handleDelete = (requestId, entityId) => {
    axios
      .put(`${baseUrl}/requests/${requestId}/entity/${entityId}`)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          fetchItems();
        } else if (response.status === 404) {
          fetchItems();
        }
      })
      .catch((error) => {
        fetchItems();
        console.error(error);
      });
  };

  const handleWholeRequestDelete = (requestId) => {
    axios
      .delete(`${baseUrl}/requests/${requestId}`)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          fetchItems();
        } else if (response.status === 404) {
          fetchItems();
        }
      })
      .catch((error) => {
        fetchItems();
        console.error(error);
      });
  };
  const [isUpdateButtonClicked, setIsUpdateButtonClicked] = useState(false);

  const handleUpdateButtonClick = () => {
    setIsUpdateButtonClicked(true);
  };
  useEffect(() => {
    if (isUpdateButtonClicked) {
      setIsUpdateButtonClicked(false);
    }
  }, [isUpdateButtonClicked]);


  const [requestModal, setRequestModal] = useState(false);
  const [currentRequestId, setCurrentRequestId] = useState(null);



  const toggleUpdateRequestModal = () => {
    window.scrollTo(0, 0); // Scrolls to top
    setRequestModal((prevState) => !prevState);
  };

  return (
    isLoading ? (
      <div className='d-flex m-5 justify-content-center' >
        <MDBSpinner style={{ width: '3rem', height: '3rem' }}>
          <span className='visually-hidden'>Loading...</span>
        </MDBSpinner>
      </div>
    ) : 
    ( 
      requests?.length>0 &&  

    <section className="mb-10 position-relative">
  
 <MDBContainer>

      <MDBRow>
      <MDBCol>
      {/* <MDBCard  className="text-center justify-content-between"> */}
      {/* <MDBCardImage cascade className="text-center rounded" style={{ height: '20rem' , borderRadius: "12px"}} src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20%281%29.jpg" />
      <MDBCardOverlay tag="section" cascade className="text-center"> */}
        <section className="grainy-gradient-intro text-center justify-content-between mt-3">
          <MDBRow style={{ marginTop: '12px', flexWrap: 'wrap', alignItems: 'start' }}>
            {!isLoading && requests.map((request, index) => {
              const { requests: reqs, createdBy, lastUpdated, domainImage, domainName } = request;
              let totalCount = 0;
              Object.values(reqs || {}).forEach(categories => {
                Object.values(categories).forEach(items => {
                  totalCount += items.length;
                });
              });
              return Object.entries(reqs || {}).map(([requestId, categories]) => (
                <MDBCol key={requestId} className='d-flex justify-content-center' >
                  <MDBCard className="d-flex flex-column  mb-4 justify-content-between" tag="section">
                  <span style={{ position: 'absolute', top: -4, right: -2 }}>
                  <MDBBadge color='danger' dark pill className='position-absolute translate-middle'>
                        {totalCount}
                      </MDBBadge>
                      </span>
                    <div className='position-relative d-inline-block'>
                      {domainImage && <MDBCardImage src={domainImage} alt='...' position='top' className='mb-3 img-thumbnail' style={{ width: '400px', height: '300px' }} fluid/>}
                    
                    </div>
                    <MDBCardHeader> <MDBChip><MDBChip > <h8 className="display-8 fw-bold text-uppercase text-dark mb-0">{(createdBy)}</h8></MDBChip>{domainName}</MDBChip></MDBCardHeader>
                    <MDBCardBody>
                      <MDBCardTitle className='text-center'>
                        <div className="d-flex justify-content-center align-items-center text-center" >
                        </div>
                      </MDBCardTitle>
                      {Object.entries(categories).map(([category, items]) => (
                        <div key={category}>
                          {categoryImages && <img src={categoryImages && categoryImages[category]} alt="" style={{ width: '30px', height: '30px', marginRight: '10px' }} className="rounded" />}
                          <a href='#!'>
                            <MDBBadge color='light' light>
                              <h6 style={{ color: 'red' }}>{capitalizeFirstLetter(category)}</h6>
                            </MDBBadge>
                            <MDBBadge color='danger' notification pill>
                              {items.length}
                            </MDBBadge>
                          </a>
                          <MDBTable>
                            <MDBTableBody>
                              {items.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className='d-flex align-items-center flex-wrap' >
                                      <div className='ms-3'>
                                        <img src={item.thumbnails && item.thumbnails[0]} alt='' className='rounded img-fluid' style={{ width: '30px', height: '30px' }} />
                                      </div>
                                      <div className='ms-3'>{capitalizeFirstLetter(item.name)}</div>
                                    </div>
                                  </td>
                                  <td>
                                    <MDBBtn size='sm' rounded color='link' onClick={() => handleDelete(requestId, item.id)}>
                                      Delete
                                    </MDBBtn>
                                  </td>
                                </tr>
                              ))}
                            </MDBTableBody>
                          </MDBTable>
                        </div>
                      ))}
                    </MDBCardBody>
                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                      <MDBBtn color='primary'
                        onClick={() => {
                          setCurrentRequestId(requestId); // Set current requestId when update is clicked
                          toggleUpdateRequestModal();
                        }}
                        className="mb-4 mb-md-0 me-2 responsive-button"
                        style={{ marginTop: '12px' }}>
                        Update
                      </MDBBtn>
                      <MDBBtn color='primary' onClick={() => handleWholeRequestDelete(requestId)} className="mb-4 mb-md-0 me-2 responsive-button" style={{ marginTop: '12px' }}>
                        Delete
                      </MDBBtn>
                    </div>
                    <MDBCardFooter>
                      <small className='text-muted'>{lastUpdated}`</small>
                    </MDBCardFooter>
                  </MDBCard>
                </MDBCol>
              ));
            })}
          </MDBRow>
          {requestModal &&
            <MDBModal open={requestModal} onClose={toggleUpdateRequestModal}>
               <MDBModalHeader toggle={toggleUpdateRequestModal}>
              
                  <MDBBtn
                    className='btn-close'
                    color='none'
                    onClick={toggleUpdateRequestModal}
                  ></MDBBtn>
                </MDBModalHeader>
              <MDBModalDialog size='xl'>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Add Items to existing request</MDBModalTitle>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <Inventory toggleUpdateRequestModal={toggleUpdateRequestModal}  isRequestUpdate={true} domainImages={domainImages} categoryImages={categoryImages}  requestId={currentRequestId} setRefetchTrigger={setRefetchTrigger} />
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          }
        </section>
        {/* </MDBCardOverlay> */}
        {/* </MDBCard> */}
        </MDBCol>

</MDBRow>
      </MDBContainer>

    </section>)
  );
}


Requests.propTypes = {
  groupedItems: PropTypes.array
};

export default Requests;
